import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import { Validator } from 'vee-validate'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { configurationSectionService } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section/configuration-section.service'
import { ConfigurationSectionResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section/configuration-section.dto'
import { SubportionStateMachineConfigurationResponse } from '@/modules/configurationModule/detail/local-laboratory-module/subportion-state-machines/services/configuration-subportion-state-machines/configuration-subportion-state-machines.dto'
import { commonSubportionTypeService } from '@/api/services/common/subportion-type/common-subportion-type.service'
import { CommonSubportionTypeResponse } from '@/api/services/common/subportion-type/common-subportion-type.dto'
import { GridUtils } from '@/shared/util/grid-utils'

@Component
export default class ConfigurationSubportionStateMachinesModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly subportionStateMachineConfiguration!: Partial<SubportionStateMachineConfigurationResponse>
    @Prop() readonly sectionId!: number

    @Inject() externalValidator!: Validator

    constructor() {
        super()

        this.$validator = this.externalValidator
    }

    get updateMode(): boolean {
        return !!this.subportionStateMachineConfiguration?.id
    }

    get laboratoryId(): number {
        return this.$store.getters.labId
    }

    async mounted() {
        if (this.sectionId) {
            const section = await this.getSectionsByCurrentLaboratory(this.sectionId)
            if (section[0]) {
                this.subportionStateMachineConfiguration.section = section[0]
            }
        }
    }

    async getSectionsByCurrentLaboratory(sectionId?: number): Promise<ConfigurationSectionResponse[]> {
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        let filterModel: CommonFilterModel = {
            active: GridUtils.getSetFilterModel(['true'])
        }
        if (sectionId) {
            filterModel.id = GridUtils.getNumberFilterModel('equals', sectionId)
        }
        const response = await this.$_toCallUnique(configurationSectionService.paginator(filterModel, params, this.laboratoryId))
        if (response) {
            return response.content
        }
        return []
    }

    async getSubportionTypes(): Promise<CommonSubportionTypeResponse[]> {
        const response = await this.$_toCallUnique(commonSubportionTypeService.getSubportionTypes())
        if (response) {
            return response.filter(subportion => subportion.sptActive)
        }
        return []
    }
}
